import { render, staticRenderFns } from "./ModuleEthBlockBatchMinting.vue?vue&type=template&id=7055d197&scoped=true"
import script from "./ModuleEthBlockBatchMinting.vue?vue&type=script&lang=js"
export * from "./ModuleEthBlockBatchMinting.vue?vue&type=script&lang=js"
import style0 from "./ModuleEthBlockBatchMinting.vue?vue&type=style&index=0&id=7055d197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7055d197",
  null
  
)

export default component.exports